import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Dropdown, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  Input,
  Div,
  DivConteudo,
  Label,
  TextArea,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const CardCombosCriar = (props) => {

  const [loading, setLoading] = useState(true);
  const [nome, setNome] = useState("");
  const [imagem, setImagem] = useState("");
  const [conteudo, setConteudo] = useState("");
  const [link, setLink] = useState("/pacotes/");
  const [valueTotal, setValueTotal] = useState(0);
  const [valueCombo, setValueCombo] = useState();
  const [optionsCombos, setOptionsCombos] = useState([]);
  const [combo, setCombo] = useState();


  useEffect(() => {
    loadAuth();
    loadCombos();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };


  const loadCombos = async () => {
    await api
      .get("/combos-nome/")
      .then((res) => {
        const newOptions = res.data.map((comb) => ({
          ...optionsCombos,
          key: comb.id_combo,
          text: comb.curso,
          value: comb.id_combo,
        }));
        setOptionsCombos(newOptions);
        setLoading(false);
      })
      .catch(() => { });
  };

  const handleSubmit = async () => {

    const payload = {
      nome: nome,
      image: imagem,
      content: conteudo,
      pageLink: link,
      valueTotal: valueTotal,
      valueCombo: valueCombo,
      idCombo: combo
    };

    await api
      .post(`/card-combo`, payload)
      .then(async (res) => {
        await systemLogs(
          "combos",
          `criou o combo de id=${res.data.id}`
        );

        swal("Sucesso!", "Criação de combo bem sucedida", "success").then(
          () => {
            window.location.href = "/admin/combos";
          }
        );
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Erro ao criar o combo",
          "Por favor, insira preencha todos os campos necessários",
          "error"
        );
      });
  };

  const modifyCombo = async (id) => {
    setLoading(true);
    setCombo(id);

    await api.get(`/cursolist/${id}`).then((res) => {
      setValueCombo(res.data.valor);
    })
    await api.get(`/combo/${id}`).then(async (res) => {
      var soma = 0;
      await Promise.all(res.data.map((comb) => (
        api.get(`/cursolist/${comb}`).then((value) => {
          soma = soma + value.data.valor;
        })
      )))
      setValueTotal(soma);
    })
    setLoading(false);
  }

  const manipulateContent = async (content) => {
    const content_array = content.split('');

    const formatted_content_array = content_array.map(char => {
      if (char === '\n') {
        return '</li><li>';
      }
      return char;
    });

    formatted_content_array[content_array.length] = '</li>';

    const formatted_content = '<li>' + formatted_content_array.join('');

    setConteudo(formatted_content);
  }

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar combos</Title>
          <Div>
            <Label>Combo: </Label>
            <Dropdown
              placeholder="Selecione o combo"
              fluid
              search
              selection
              options={optionsCombos}
              onChange={(e, data) => { modifyCombo(data.value) }
              }
            />
          </Div>
          {loading ? (
            <Loader active inline="centered" size="massive" />
          ) : (
            <>
              <Div>
                <Label>Nome: </Label>
                <DivConteudo>
                  <Input type="text" onChange={e => setNome(e.target.value)} />
                </DivConteudo>
              </Div>
              <Div>
                <Label>Imagem: </Label>
                <DivConteudo>
                  <Input type="text" value={imagem} onChange={e => setImagem(e.target.value)} />
                </DivConteudo>
              </Div>
              <Div>
                <Label>Conteudo: </Label>
                <DivConteudo>
                  <TextArea rows="5" onChange={e => manipulateContent(e.target.value)} />
                </DivConteudo>
              </Div>
              <Div>
                <Label>Link da página do pacote: </Label>
                <DivConteudo>
                  <Input type="text" placeholder="/pacotes/" value={link} onChange={e => setLink(e.target.value)} />
                </DivConteudo>
              </Div>
              <Div>
                <Label>Valor total: </Label>
                <DivConteudo>
                  <Input type="number" value={valueTotal} onChange={e => setValueTotal(e.target.value)} />
                </DivConteudo>
              </Div>
              <Div>
                <Label>Valor do Combo: </Label>
                <DivConteudo>
                  <Input type="number" value={valueCombo} onChange={e => setValueCombo(e.target.value)} />
                </DivConteudo>
              </Div>
              <Button onClick={handleSubmit}>
                <Icon name="save" />
                Salvar
              </Button>
            </>
          )}
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CardCombosCriar);
